import React, { useState } from "react";
import FormSubtext from "components/Form/components/FormSubtext";
import "./style.scss";
import PropTypes from "prop-types";

const AssetUploader = ({
  id,
  classes,
  name,
  label,
  error,
  register,
  ...inputProps
}) => {
  const [base64File, setBase64File] = useState("");
  const [labelValue, setLabel] = useState(label);
  const [fileIsValid, setFileIsValid] = useState(true);

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64File(reader.result.toString());
    };
    reader.readAsDataURL(file);
  };

  const handleInputChange = (fileData) => {
    if (fileData?.target.files.length > 0) {
      const file = fileData.target.files[0];
      setFileIsValid(fileData.target.validity);
      convertToBase64(file);
      setLabel("Replace Image");
    }
  };

  return (
    <div className="image-uploader">
      <div className="image-uploader__box">
        <input
          type="file"
          {...register(name)}
          id={id}
          className={`field ${classes}`}
          required={inputProps.required}
          onChange={handleInputChange}
        />
        <span className="label">{labelValue}</span>
        <label htmlFor={id} className="link-button --bold --primary">
          {inputProps.placeholder}
        </label>
        {inputProps.subtext && <FormSubtext text={inputProps.subtext} />}
        {!fileIsValid && "<p>Please try a different file</p>"}
      </div>
      <div className="image-uploader__preview">
        <div className="image-uploader__pic">
          {base64File && (
            <img
              src={base64File}
              alt="uploaded_image"
              style={{ maxWidth: "100%" }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

AssetUploader.propTypes = {
  // common
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  register: PropTypes.func.isRequired,
  error: PropTypes.shape({ message: PropTypes.string.isRequired }),

  // specific
  type: PropTypes.string,
  required: PropTypes.bool,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
};

export default AssetUploader;
